<template>
  <div class="outer">
    <div class="row gx-2 gx-lg-3 justify-content-center my-lg-1">
      <!-- [戻る] -->
      <div class="col-4 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2">
        <button
          type="button"
          class="js-colorbox-close btn btn-reset rounded-pill w-100 py-2 px-xxl-5"
          @click="hideRentalContractModal()"
        >
          戻る
        </button>
      </div>
      <!-- ./[戻る] -->

      <!-- [登録] -->
      <div class="col-4 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2">
        <button
          type="button"
          class="js-colorbox-close btn btn-c03 rounded-pill w-100 py-2 px-xxl-5"
          :disabled="rentalContractEditForm.isDisableButtons.registration"
          @click="clickRentalContractRegistrationButton()"
        >
          登録
        </button>
      </div>
      <!-- ./[登録] -->

      <!-- [完了] -->
      <div class="col-4 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2">
        <button
          type="button"
          class="js-colorbox-close btn btn-c01 rounded-pill w-100 py-2 px-xxl-5"
          @click="clickRentalContractCompleteButton()"
          :disabled="rentalContractEditForm.isDisableButtons.complete"
        >
          完了
        </button>
      </div>
      <!-- ./[完了] -->

      <!-- [出力] -->
      <div class="col-5 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2">
        <button
          type="button"
          class="js-colorbox-close btn btn-warning rounded-pill w-100 py-2 px-xxl-5"
          @click="clickRentalContractExportButton()"
          :disabled="rentalContractEditForm.isDisableButtons.export"
        >
          出力
        </button>
      </div>
      <!-- ./[出力] -->

      <!-- [LINEコピー] -->
      <div class="col-5 col-sm-4 col-md-2 col-lg-2 col-xxl-auto mt-2">
        <button
          type="button"
          class="js-colorbox-close btn btn-c02 rounded-pill w-100 py-2 px-xxl-5"
          @click="copyLineClipboardByRentalContract()"
          :disabled="rentalContractEditForm.isDisableButtons.export"
        >
          LINEコピー
        </button>
      </div>
      <!-- ./[LINEコピー] -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.outer -->
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
/* Import Components */
/* Import Variables */
import { rentalContractEditForm } from "../../../compositions/variables";
/* Import Functions */
import {
  clickRentalContractRegistrationButton,
  clickRentalContractCompleteButton,
  clickRentalContractExportButton,
} from "../../../compositions/script/submitRentalContract";
import { hideRentalContractModal } from "../../../compositions/rentContract/modal";
import { copyLineClipboardByRentalContract } from "../../../compositions/rentContract/lineCopyByRentalContract";
export default defineComponent({
  setup() {
    return {
      /* Variables. */
      rentalContractEditForm,
      /* Functions. */
      clickRentalContractRegistrationButton,
      clickRentalContractCompleteButton,
      clickRentalContractExportButton,
      copyLineClipboardByRentalContract,
      hideRentalContractModal,
    };
  },
});
</script>
